import React from 'react';
import backgroundImage from "../images/Background-Without-Light.png";
// import kaydetButtonImage from '../images/KaydetButton.png';
// import devamEtButtonImage from '../images/DevamEtButton.png';
import styles from './IntroPages.module.css';
// import { useParams } from 'react-router-dom';
import innovationButton from "../images/tr/InnovationRDButton.png";
import strategyButton from "../images/tr/StrategyButton.png";
import sustainabilityButton from "../images/tr/SustainabilityButton.png";
import technologyButton from "../images/tr/TechnologyButton.png";
import systemButton from "../images/tr/SystemButton.png";
// import aiButton from "../images/AIButton.png";
import coreXSystemImage from "../images/CoreXSystemLogo.png";
import corexasLogoWithText from "../images/CorexasLogoWithText.png";

function SelectQuizPage({ navigate }) {
    // const { quizType } = useParams();
    // const [quizName, setQuizName] = useState("");

    // useEffect(() => {
    //     switch (quizType) {
    //         case "future":
    //             setQuizName("Future");
    //             break;
    //         case "digitalization":
    //             setQuizName("Digitalization");
    //             break;
    //         case "sustainability":
    //             setQuizName("Sustainability");
    //             break;
    //         case "startup":
    //             setQuizName("Startup");
    //             break;
    //         default:
    //             break;
    //     }
    // }, [quizType])


    return (
        <div className={styles.intropage} style={{ backgroundImage: `url(${backgroundImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", fontFamily: "Bookman Old Style", flexDirection: "column" }}>
            <div className={styles.content} style={{ flexDirection: "column" }}>
                <img src={coreXSystemImage} alt="CoreXFuture" style={{ height: "25vh", alignSelf: "center", cursor: "pointer" }} onClick={() => {navigate("/intro")}} />
                <div style={{ height: "75vh", flexDirection: "row", display: "flex", justifyContent: "space-evenly", paddingBottom: "5vh" }}>
                    <div style={{ flexDirection: "column", justifyContent: "space-evenly", alignItems: "center", display: "flex" }}>
                        <img style={{ cursor: "pointer", height: "30vh" }} src={technologyButton} alt="" onClick={() => navigate('/quizstart/technology')} />
                        {/* <img style={{ cursor: "pointer", height: "30vh" }} src={technologyButton} alt="" onClick={() => navigate('/quiz/technology/OperasyonAnaBoyut.json/OPERASYON')} /> */}
                        <img style={{ cursor: "pointer", height: "30vh" }} src={strategyButton} alt="" onClick={() => navigate('/quizstart/strategy')} />
                    </div>
                    <div style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                        <img style={{ cursor: "pointer", height: "30vh" }} src={systemButton} alt="" onClick={() => navigate('/intro')} />
                        {/* <img style={{ cursor: "pointer", height: "30vh" }} src={strategyButton} alt="" onClick={() => navigate('/quiz/strategy/StratejiAnaBoyut.json/STRATEJİ')} /> */}
                    </div>
                    <div style={{ flexDirection: "column", justifyContent: "space-evenly", alignItems: "center", display: "flex" }}>
                        <img style={{ cursor: "pointer", height: "30vh" }} src={innovationButton} alt="" onClick={() => navigate('/quizstart/innovation')} />
                        {/* <img style={{ cursor: "pointer", height: "30vh" }} src={innovationButton} alt="" onClick={() => navigate('/quiz/innovation/ProblemAnaBoyut.json/PROBLEM')} /> */}
                        <img style={{ cursor: "pointer", height: "30vh" }} src={sustainabilityButton} alt="" onClick={() => navigate('/quizstart/sustainability')} />
                        {/* <img style={{ cursor: "pointer", height: "30vh" }} src={sustainabilityButton} alt="" onClick={() => navigate('/quiz/sustainability/ProblemAnaBoyut.json/PROBLEM')} /> */}
                    </div>
                </div>
            </div>
            <img src={corexasLogoWithText} alt="CoreXFuture" style={{ position: "absolute", height: "10vh", maxHeight: "50px", bottom: "5vh" }} />
        </div>
    );
}

export default SelectQuizPage;